<script>
import Move from './Move.vue'
import Instruction from './Instruction.vue'
import Round from './Round.vue'

export default {
    name: 'DynamicItem',
    props: ['item', 'circuit'],
    components: {
        Move,
        Instruction,
        Round
    },
    computed: {
        renderComponent(){
            const item = this.item
            if (item.type === 'filler') {
                return 'move'
            }
            else {
                return item.type
            }
        }
    }
};
</script>
<template>
    <component v-bind:is="renderComponent" :item="item" :circuit="circuit" :parentItem="item"></component>
</template>